import CommonRouter from './CommonRouter'
import { settingsRoutes } from '../routes/SettingsRoutes'

const CurrentNavigator = CommonRouter('Settings', settingsRoutes.Settings)
export default CurrentNavigator
